import { FC } from 'react';

import { useSelectorNonNullable } from '@hh.ru/redux-create-reducer';

import { SECTION_SKILLS_ID } from 'src/pages/CertLanding/constants';

import Item from 'src/pages/CertLanding/components/SectionSkills/components/Item';

import styles from './styles.less';

const SectionSkills: FC = () => {
    const skills = useSelectorNonNullable((state) => state.pageCert.shortSkills);

    return (
        <section id={SECTION_SKILLS_ID}>
            <ul className={styles.list}>
                {skills.map((skill) => (
                    <li className={styles.item} key={skill.id}>
                        <Item {...skill} />
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default SectionSkills;
